export default __webpack_public_path__ + "static/media/ico-ig-white.19c119e4.svg";